import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, UtensilsCrossed, Sparkles, Music, Camera, Car } from 'lucide-react';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
export function ServicesPage() {
  const services = [{
    icon: ClipboardList,
    title: 'Event Planning & Coordination',
    description: 'From concept to execution, our dedicated team handles every detail so you can enjoy your special day.'
  }, {
    icon: UtensilsCrossed,
    title: 'Full-Service Catering',
    description: 'Exquisite menus crafted by our executive chef, from elegant plated dinners to lavish buffet spreads.'
  }, {
    icon: Sparkles,
    title: 'Custom Décor & Design',
    description: 'Transform our spaces with bespoke floral arrangements, lighting design, and themed décor packages.'
  }, {
    icon: Music,
    title: 'Entertainment & AV',
    description: 'State-of-the-art sound systems, DJ services, live band staging, and multimedia presentations.'
  }, {
    icon: Camera,
    title: 'Photography & Videography',
    description: 'Capture every moment with our network of professional photographers and videographers.'
  }, {
    icon: Car,
    title: 'Valet & Transportation',
    description: 'Seamless arrival experience with valet parking, shuttle services, and luxury car arrangements.'
  }];
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen w-full bg-h2o-950 text-slate-100 flex flex-col pt-20" data-id="element-430">
      {/* Hero Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-431">
        <div className="absolute inset-0 z-0" data-id="element-432">
          <img src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1920&q=80" alt="Event Services" className="w-full h-full object-cover object-center" data-id="element-433" />
          <div className="absolute inset-0 bg-h2o-950/80" data-id="element-434" />
        </div>
        <div className="relative z-10 text-center px-6" data-id="element-435">
          <motion.h1 initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-4xl md:text-6xl font-bold text-white mb-4" data-id="element-436">
            Our Services
          </motion.h1>
          <motion.p initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-437">
            Comprehensive event solutions tailored to your unique vision.
          </motion.p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto w-full" data-id="element-438">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-439">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <motion.div key={service.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-h2o-800/50 border border-slate-700/50 rounded-lg p-8 hover:border-h2o-cyan/30 transition-colors group" data-id="element-440">
                <div className="w-14 h-14 rounded-lg bg-h2o-900 flex items-center justify-center mb-6 border border-slate-700 group-hover:border-h2o-cyan/50 transition-colors" data-id="element-441">
                  <Icon className="w-7 h-7 text-h2o-cyan" data-id="element-442" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-443">
                  {service.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-444">
                  {service.description}
                </p>
              </motion.div>;
        })}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-h2o-900 border-t border-slate-800 text-center" data-id="element-445">
        <div className="max-w-3xl mx-auto" data-id="element-446">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-447">
            Ready to start planning?
          </h2>
          <p className="text-slate-400 mb-8 text-lg" data-id="element-448">
            Let our expert team curate a custom package that brings your vision
            to life.
          </p>
          <Link to="/contact" className="inline-block bg-h2o-cyan text-h2o-950 font-semibold px-8 py-4 rounded-lg hover:bg-h2o-cyan-light transition-colors focus-visible-ring" data-id="element-449">
            Request a Custom Package
          </Link>
        </div>
      </section>

      <Footer data-id="element-450" />
    </motion.main>;
}